import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule';
import app from './app';
import appConfig from './app-config';
import user from './user';
import verticalMenu from './vertical-menu';
import whatsapp from './whatsapp';

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});
export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  modules: {
    app,
    appConfig,
    verticalMenu,
    // 'app-ecommerce': ecommerceStoreModule,
    user,
    // whatsapp,
  },

  strict: process.env.DEV,

  state: {
    uploadUrl: 'https://upload.myskool.app',
    userData: {
      userID: 0,
      categoryId: 0,
      username: '',
      password: '',
      rememberMe: false,
      isLoggedIn: false,
      userType: 0,
      roles: null,
      token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxIiwiZW1haWwiOiJhZG1pbkBpYmljby5jb20iLCJuYW1lIjoiYWRtaW4iLCJidXNpbmVzc0lEIjoiMSIsInJvbGUiOiIwIiwianRpIjoiMThkNTFmNjQtYzA3Mi00ZGI3LTg5NjItM2FhMDcyYjlhOTI1IiwiZXhwIjoxNzQzNTg0NjIwLCJpc3MiOiJpYmljby5lcnAiLCJhdWQiOiJpYmljby5lcnAifQ.Eb5jp0qBCs74RvZzf_m1w41r7r8Fu41ulLTxF1nb0S8',
    },
    userObj: {},
    userID: 0,
    businessID: 0,
    userRights: [],
  },
  mutations: {
    setApiUrl(state, payload) {
      state.apiUrl = payload;
    },
    setToken(state, payload) {
      state.userData.token = payload;
    },
    setUserObj(state, payload) {
      state.userObj = payload;
    },
    setUserID(state, payload) {
      state.userID = payload;
    },
    setBusinessID(state, payload) {
      state.businessID = payload;
    },
    setUserRights(state, payload) {
      state.userRights = payload;
    },
  },
});
